/* eslint-disable */

import RevampAPIServices from '@/services/revampApi';
import PaymentAPIServices from '@/services/paymentApi';
import PgwAPIServices from '@/services/pgwApi';
import TokenPaymentAPIServices from '@/services/tokenPaymentApi';
import LocalStorage from '@/services/localstorage';

const v1 = 'api/microsite/v1';
const paxelBoxV1 = 'api/paxelbox/v1';
const token = 'auth/token';
const payment = 'api/v1/order';
const box = 'api/v1/box';
const general = 'api/v1';

// actions
const actions = {
  changeLanguage({ commit }, data) {
    commit('setLanguage', data);
  },
  fetchPaxelBoxBanners({ commit }, data) {
    RevampAPIServices.post(`/${v1}/microsite-banner/${data.language}/find-all-published-with-paging/${data.limit}`)
      .then((response) => {
        const responseData = response.data;
        if (responseData.code === 200) {
          commit('setPaxelBoxBanners', responseData.data);
        } else {
          commit('setPaxelBoxBanners', []);
        }
      })
      .catch(() => {
        commit('setPaxelBoxBanners', []);
      });
  },
  fetchPaxelBoxServices({ commit }, data) {
    RevampAPIServices.post(`/${v1}/microsite-service/${data.language}/find-all-published-with-paging/${data.limit}`)
      .then((response) => {
        const responseData = response.data;
        if (responseData.code === 200) {
          commit('setPaxelBoxServices', responseData.data);
        } else {
          commit('setPaxelBoxServices', []);
        }
      })
      .catch(() => {
        commit('setPaxelBoxServices', []);
      });
  },
  sendGuestBook({ commit }, data) {
    return new Promise((resolve, reject) => {
      RevampAPIServices.post(`/${v1}/microsite-guest-book/id/guest-book`, data)
        .then((response) => {
          const responseData = response.data;
          commit('setGuestBook', responseData.data);
          resolve(response);
        })
        .catch((error) => {
          commit('setGuestBook', []);
          reject(error);
        });
    });
  },
  fetchAvailableLockerSize({ commit }, id) {
    RevampAPIServices.get(`/${v1}/microsite-locker-dispatcher/locker-size/${id}`)
      .then((response) => {
        const responseData = response.data;
        if (responseData.code === 200) {
          commit('setAvailableLockers', responseData.data);
        } else {
          commit('setAvailableLockers', []);
        }
      })
      .catch(() => {
        commit('setAvailableLockers', []);
      });
  },
  sendPackageData({ commit }, data) {
    RevampAPIServices.post(`/${v1}/microsite-locker-dispatcher`, data)
      .then((response) => {
        const responseData = response.data;
        if (responseData.code === 200) {
          commit('setPackageLocker', responseData.data);
        } else {
          commit('setPackageLocker', {});
        }
      })
      .catch(() => {
        commit('setPackageLocker', {});
      });
  },
  getShortener({ commit }, code) {
    RevampAPIServices.get(`/${paxelBoxV1}/shortening-url/${code}`)
      .then((response) => {
        const responseData = response.data;
        if (responseData.code === 200) {
          commit('setShortener', responseData.data);
        } else {
          commit('setShortener', {});
        }
      })
      .catch(() => {
        commit('setShortener', {});
      });
  },
  getOverdueDropoffDetail({ commit }, orderId) {
    return new Promise((resolve, reject) => {
      RevampAPIServices.get(`/${v1}/overdue-dropoff/check/${orderId}`)
        .then((response) => {
          const responseData = response.data;
          if (responseData.code === 200) {
            commit('setOverdueDropOffDetail', responseData.data);
            LocalStorage.setOverdue(JSON.stringify(responseData.data));
            resolve(responseData.data);
          } else {
            commit('setOverdueDropOffDetail', {});
            resolve(responseData.data);
          }
        })
        .catch((error) => {
          commit('setOverdueDropOffDetail', {});
          LocalStorage.removeOverdue();
          reject(error);
        });
    });
  },
  sendOverdueDropoff({ commit }, data) {
    return new Promise((resolve, reject) => {
      RevampAPIServices.post(`/${v1}/overdue-dropoff/payment-log/${data.orderId}`, data.formdata)
        .then((response) => {
          const responseData = response.data;
          if (responseData.code === 200) {
            commit('setOverdueDropOff', response);
            resolve(response);
          } else {
            commit('setOverdueDropOff', {});
            resolve(response);
          }
        })
        .catch((error) => {
          commit('setOverdueDropOff', {});
          reject(error);
        });
    });
  },
  getTokenPayment() {
    return new Promise((resolve, reject) => {
      TokenPaymentAPIServices.get(`/${token}/generate`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createPayment({ commit }, data) {
    return new Promise((resolve, reject) => {
      PaymentAPIServices.post(`/${payment}/multiple/locker?access_token=${data.token}`, data.formdata)
        .then((response) => {
          const responseData = response.data;
          if (responseData.code === 200) {
            resolve(responseData.data);
          } else {
            resolve(responseData.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getOrderDetail({ commit }, orderId) {
    return new Promise((resolve, reject) => {
      RevampAPIServices.get(`/${v1}/order/${orderId}`)
        .then((response) => {
          const responseData = response.data;
          if (responseData.code === 200) {
          
            resolve(responseData.data);
          } else {
            resolve(responseData.data);
          }
        })
        .catch((error) => {
          commit('setOverdueDropOffDetail', {});
          LocalStorage.removeOverdue();
          reject(error);
        });
    });
  },
  validateUser({ commit }, param) {
    return new Promise((resolve, reject) => {
      RevampAPIServices.get(`/api/webview/v1/members/auth?token=${param.token}`)
        .then((response) => {
          commit('setLanguage', response.data.data.language);
          commit('setUserData', response.data.data);
          LocalStorage.setUserData(JSON.stringify(response.data.data));
          resolve(response);
        })
        .catch((error) => {
          console.log("ERROR")
          reject(error);
        }).finally(() => {
        });
    });
  },
  getOrderStatus({ commit }, orderId) {
    return new Promise((resolve, reject) => {
      PgwAPIServices.get(`/${box}/express/info/${orderId}/paid`)
        .then((response) => {
          LocalStorage.setOrderId(orderId);
          LocalStorage.setOrderData(JSON.stringify(response.data.data));
          commit('setOrderDetail', response.data.data);
          resolve(response.data);
        })
        .catch((error) => {
          commit('setOverdueDropOffDetail', {});
          LocalStorage.removeOverdue();
          reject(error);
        });
    });
  },
  getBoxStatus({ commit }, boxId) {
    return new Promise((resolve, reject) => {
      PgwAPIServices.get(`/${box}/lockers/detail/${boxId}?rent-availability=0`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  temporaryQrcode({ commit },data) {
    return new Promise((resolve, reject) => {
      PgwAPIServices.post(`/${box}/qrcode/temporary`,data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  cancelRent({ commit },data) {
    return new Promise((resolve, reject) => {
      PgwAPIServices.post(`/${box}/express/cancelBooking`,data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  payOverdue({ commit },data) {
    return new Promise((resolve, reject) => {
      PgwAPIServices.post(`/${box}/payments`,data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getSettings({ commit }) {
    return new Promise((resolve, reject) => {
      PgwAPIServices.get(`/${general}/settings`)
        .then((response) => {
          commit('setSettings', response.data.data);
          resolve(response.data.data)
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setOrderStatus({ commit }, data) {
    commit('setOrderStatus', data);
  },
  payOverdueRental({ commit },data) {
    return new Promise((resolve, reject) => {
      PaymentAPIServices.post(`/${payment}/locker?access_token=${data.token}`, data.formdata)
        .then((response) => {
          const responseData = response.data;
          if (responseData.code === 200) {
            resolve(responseData.data);
          } else {
            resolve(responseData.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getOverdueCalculationRentals({ commit }, order_id) {
    return new Promise((resolve, reject) => {
      PgwAPIServices.get(`/${box}/rental/overdue-calculation/${order_id}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  overdueQrcode({ commit },data) {
    return new Promise((resolve, reject) => {
      PgwAPIServices.post(`/${box}/qrcode/payment`,data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  payOverdueDropoffSnapBi({ commit },data) {
    return new Promise((resolve, reject) => {
      RevampAPIServices.post(`/${v1}/overdue-dropoff/payments`,data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
        
    });
  },

  stopRentWithoutScanQr({ commit },data) {
    return new Promise((resolve, reject) => {
      PgwAPIServices.post(`/${box}/lockers/rental/stop`,data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
        
    });
  },
  getPaxelboxSettings({ commit }, filter) {
    return new Promise((resolve, reject) => {
      PgwAPIServices.get(`/${box}/settings/filter?name=${filter}`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default actions;
